/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIdcsExternalGroupAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11h-2V4H4v16h10v2H4a2 2 0 0 1-2-2zm10 3a.714.714 0 1 0 0 1.429A.714.714 0 0 0 12 7zm-2.702.456a2.715 2.715 0 0 1 5.404 0 5.308 5.308 0 0 1 1.841 1.842 2.715 2.715 0 0 1 0 5.404 5.309 5.309 0 0 1-1.84 1.842 2.715 2.715 0 0 1-5.405 0 5.307 5.307 0 0 1-1.842-1.842 2.715 2.715 0 0 1 0-5.404 5.308 5.308 0 0 1 1.842-1.842zm.621 2.001a3.31 3.31 0 0 0-.462.462c.594.498.972 1.245.972 2.08 0 .837-.378 1.584-.972 2.082.138.169.293.324.462.462A2.709 2.709 0 0 1 12 13.57c.836 0 1.583.378 2.081.972.169-.138.324-.293.462-.462a2.708 2.708 0 0 1-.972-2.08c0-.836.378-1.583.972-2.081a3.305 3.305 0 0 0-.462-.462 2.708 2.708 0 0 1-2.08.972 2.708 2.708 0 0 1-2.082-.972zm-2.205 1.829a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428zm8.572 0a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428zM12 15.57A.714.714 0 1 0 12 17a.714.714 0 0 0 0-1.429zM19.586 19l-1.293-1.293 1.414-1.414L23.414 20l-3.707 3.707-1.414-1.414L19.586 21H16v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIdcsExternalGroupAvatar as IdcsExternalGroupAvatar };
